<template>
  <component :is="tag" class="n-list" v-on="$listeners">
    <slot name="subheader">
      <div class="subheader" v-if="hasSubheader">{{ subheader }}</div>
    </slot>

    <div class="list">
      <slot />
    </div>
    <div v-if="divider" class="divider-wrapper"><n-divider /></div>
  </component>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class NMenuGroup extends Vue {
  @Prop({ default: 'div' }) tag!: 'div' | 'ul' | 'nav'
  @Prop({ type: String }) subheader!: string
  @Prop({ type: Boolean, default: false }) divider?: boolean

  get hasSubheader(): boolean {
    return !!this.subheader
  }
}
</script>

<style scoped lang="scss">
@use '@/assets/styles' as *;
.n-list {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  flex-grow: 1;
  .list {
    display: flex;
    width: 100%;
    flex-direction: column;
    align-items: flex-start;

    &::-webkit-scrollbar-thumb {
      background-color: transparent;
    }
    &:hover {
      &::-webkit-scrollbar-thumb {
        background-color: $notch-color-neutral-sand-300;
      }
    }
  }

  .subheader {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    padding: $notch-space-2x $notch-space-3x $notch-space-1x;
    color: $notch-color-neutral-sand-600;

    @include notch-text-overline-M;
  }
}

.divider-wrapper {
  padding: $notch-space-2x $notch-space-3x;
  width: 100%;
}
</style>
